import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { SETTINGS_INJECTION_TOKENS } from '@tourfold/shared-kernels/settings-registry';
import { ResourceAccessGuard } from '@tourfold/shared-kernels/resource-access';
import { AreasSettings } from './settings-areas.component';

export function provideSettingsElementAreas(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: SETTINGS_INJECTION_TOKENS,
      useValue: {
        path: 'areas',
        name: 'Areas',
        icon: 'tf-settings-areas',
        component: AreasSettings,
        order: 9,
        translateName: 'SETTINGS_AREAS.TITLE',
        resource_key: 'areas',
        required_action: 'read',
        canActivate: [ResourceAccessGuard],
        category: {
          id: 'workspace',
          name: 'Workspace',
          order: 1,
          translateName: 'SETTINGS.CATEGORIES.WORKSPACE',
        },
      },
      multi: true,
    },
  ]);
}
